import { parseNumberByPrecision } from '@pascal/pascal-core';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { gameStore } from '../store';

export const checkMaxAutoCashOutValue = (betAmount, maxWin) => {
  const { minOdd } = gameStore;
  if (betAmount > 0) {
    const maxAutoCashOutOdd = maxWin / betAmount;
    const result =
      maxAutoCashOutOdd === maxAutoCashOutOdd < minOdd
        ? minOdd
        : parseNumberByPrecision(1, maxAutoCashOutOdd, 1) || minOdd;
    gameConfigStore.setMaxAutoCashOutOdd(result);

    return result;
  }
  return null;
};
